import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import moment from 'moment'
import cn from 'classnames'

import './style.scss'
import { withTranslation } from 'react-i18next'

const baseClass = 'level-item'

export const LevelItem = ({
  t,
  i18n: { language },
  image,
  name,
  activities,
  streak,
  proTrackId,
  color,
  proTrackName,
  finishDate,
  finishedIn,
}) => (
  <div className={baseClass}>
    <div
      className={`${baseClass}__img-wrapper`}
      style={{
        backgroundColor: color,
      }}
    >
      <img src={image} className={`${baseClass}__img`} alt={image} />
    </div>
    <div className={`${baseClass}__wrapper`}>
      <div className={`${baseClass}__name-completed-streak`}>
        <div className={`${baseClass}__protrack-name`}>
          {`${proTrackName} `}
          <span className={`${baseClass}__protrack-level`}>{`(${name})`}</span>
          <span className={`${baseClass}__organizationName`}>
            {t(`was-completed-in`, { organization: finishedIn.orgName })}
          </span>
          <img className={`${baseClass}__organizationLogo`} src={`${finishedIn.logo}`} alt={`${finishedIn.orgName}`} />
        </div>
        <div className={`${baseClass}__completed-streak`}>
          <div className={`${baseClass}__completed`}>
            <span className={`${baseClass}__amount`}>{activities}</span>
            <span className={`${baseClass}__text`}>{t('Activities Completed')}</span>
          </div>
          <div className={`${baseClass}__streak`}>
            <span className={`${baseClass}__amount`}>{streak}</span>
            <span className={`${baseClass}__text`}>{t('Best Streak')}</span>
          </div>
          <div>
            <span className={`${baseClass}__amount`}>{t('Finished on')}</span>
            <span className={`${baseClass}__amount`}>{moment(finishDate).format('MM/DD/YYYY')}</span>
          </div>
        </div>
      </div>
      <div className={`${baseClass}__link`}>
        <Link
          to={`/completed-pro-tracks/${proTrackId}/activity`}
          className={cn(`${baseClass}__link-view`, {
            [`${baseClass}__link-view__${language}`]: language,
          })}
        >
          {t('View Details')}
        </Link>
      </div>
    </div>
  </div>
)

LevelItem.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  activities: PropTypes.number.isRequired,
  streak: PropTypes.number.isRequired,
  proTrackId: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
}

export default withTranslation('user')(LevelItem)
